export const ENDPOINTS = {
  // LOGIN --------------------------------------------
  LOGIN_ACCESS: '/user/access',
  LOGIN_GET_INFO: '/user/',
  LOGIN_GET_AUTH_HACIENDA: '/Gateway/Autenticacion',
  REFRESH_TOKE_POST: '/user/refreshToken',
  REFRESH_TOKEN_CORE: '/Operaciones/RefreshToken',
  GET_CONFIG_INFO: '/user/configData',

  // CREACION DE CUENTA FACTURADOR --------------------------------------------
  CREAR_USUARIO_VERIFICAR_CODIGO_EMPRESA: '/user/verifyCompanyCode',
  CREAR_USUARIO_VERIFICAR_EMAIL: '/user/validate/',
  CREAR_USUARIO_CREACION: '/user',
  CREAR_USUARIO_PREELIMINAR: '/user/preRegister',
  CREAR_USUARIO_ENVIAR_EMAIL: '/user/validation',
  OBTENER_USERNAME: '/user/generateUsername',
  VALIDAR_USERNAME: '/user/validateUsername',
  VERIFICAR_SOLO_USERNAME: '/user/verifyUsername',

  // TOKEN GATEWAY Y HACIENDA --------------------------------------------
  GATEWAY_AUTENTICACION: '/Gateway/Autenticacion',

  // ACCIONES --------------------------------------------
  OPERACIONES_ENVIO_CORREO: '/Operaciones/EnvioCorreo',
  OPERACIONES_IMPRESION: process.env.REACT_APP_EMISION_API
    ? `${process.env.REACT_APP_EMISION_API}/Operaciones/Impresion`
    : '/Operaciones/Impresion',
  OPERACIONES_IMPRESION_ID: process.env.REACT_APP_EMISION_API
    ? `${process.env.REACT_APP_EMISION_API}/Operaciones/GetHtmlFactura`
    : '/Operaciones/GetHtmlFactura',
  OPERACIONES_EXCEL: '/Operaciones/ObteneDatosExcel',

  GET_CONTINGENCIA_TRAZABILIDAD: '/Contingencia/Trazabilidad',
  GET_CONTINGENCIA_DOCUMENTO: '/Contingencia/Documento',

  // HISTORIAL --------------------------------------------
  GET_HISTORIAL_TRANSACCIONES: '/Operaciones/GetTransaccion',
  GET_HISTORIAL_TIPOS_DOCUMENTOS: '/Catalogo/GetTipoDocumento',

  // CATALOGOS --------------------------------------------
  GET_DEPARTAMENTOS: '/Catalogo/GetDepartamento',
  GET_BANCOS: '/Catalogo/GetBancos',
  GET_MUNICIPIOS: '/Catalogo/GetMunicipio',
  GET_TIPO_ESTABLECIMIENTOS: '/Catalogo/GetTipoEstablecimiento',
  GET_TIPO_PERSONA: '/Catalogo/GetTipoEmpresa',
  GET_ACTIVIDAD_ECONOMICA: '/Catalogo/GetActividadEconomica',
  GET_PLANFACTURAS: '/user/getRequest/2',
  GET_TIPO_IDENTIFICACION: '/Catalogo/GetTipoIdentificacion',
  GET_TIPO_DOCUMENTOS: '/Operaciones/getDocs',
  GET_NOMBRE_DEPARTAMENTO: '/Catalogo/GetNombreDepartamento',
  GET_NOMBRE_MUNICIPIO: '/Catalogo/GetNombreMunicipio',
  GET_BOTONES_AYUDA: '/user/configMessages',
  GET_CONDICION_OPERACION_CAT016: '/Catalogo/GetCondicionOperacion',
  GET_RECINTO_FISCAL: '/Catalogo/GetRecintoFiscal',
  GET_REGIMEN: '/Catalogo/GetRegimen',
  GET_INCONTERMS: '/Catalogo/GetIncoterms',
  GET_FORMA_PAGO: '/Catalogo/GetFormaPago',
  GET_PAISES: '/Catalogo/GetPais',
  GET_UNIDAD_MEDIDA: '/Catalogo/GetUnidadMedida',
  GET_FECHA: '/Operaciones/GetFecha',
  GET_PLAZO_PAGO: '/Catalogo/GetPlazo',
  GET_SUSCRIPCIONES: '/Catalogo/GetTipoSuscripcion',
  GET_SERVICIOS_ADICIONALES: '/Catalogo/GetServiciosAdicionales',
  GET_TIPOS_CARGOS_MEMBRESIA: '/Catalogo/37',
  GET_IMPUESTOS_PRODUCTO: '/Catalogo/GetImpuestos',
  GET_PRODUCTOS: '/Catalogo/GetCatalogoProductos',

  // FACTURACIÓN - EMITIR FACTURA --------------------------------------------
  FACTURACION_GET_EMPRESA_EMISOR: '/Gateway/GetEmpresa',
  FACTURACION_POST_SUCURSALES: '/Usuario/GetSucursales',
  FACTURACION_GET_UUID: '/Operaciones/ObtenerUUID',
  FACTURACION_ANULAR: '/Gateway/AnularDTE',
  FACTURACION_POST_RECEPCION_DTE: process.env.REACT_APP_EMISION_API
    ? `${process.env.REACT_APP_EMISION_API}/Gateway/RecepcionDTE`
    : '/Gateway/RecepcionDTE',
  FACTURACION_GET_QR: '/Operaciones/ObtenerQR',

  // OLVIDO CONTRASEÑA --------------------------------------------
  OLVIDO_PASS_ENVIAR_EMAIL: '/user/recover',
  OLVIDO_PASS_VERIFICAR_CODIGO: '/user/verifyCodePass',
  OLVIDO_PASS_PUT_NUEVA_PASS: '/user/recover',
  RESTABLECER_PASS_TEMPORAL: '/user/changePassNewUser',

  // GESTIÓN DE USUARIOS --------------------------------------------
  GESTION_USUARIO_POST_SUCURSALES: '/Usuario/GetSucursales',
  GESTION_USUARIO_POST_ASIGNAR_SUCURSALES: '/Usuario/InsertUsuarioSucursal',
  GESTION_USUARIO_PUT_ACEPTAR_USUARIO: '/user/modRequest',
  GESTION_USUARIO_GET_INFO: '/user',
  GESTION_USUARIO_GET_USUARIOS: '/user/getUsers',
  GESTION_USUARIO_POST_RESET_PASSWORD_CLIENTES: '/user/restorePassword',
  GESTION_USUARIO_DELETE_USUARIO: '/user',
  GESTION_USUARIO_UPDATE_USUARIO: '/user/updateUser',
  GESTION_USUARIO_GET_ESTADOS_DOCUMENTO: '/Operaciones/getDocs',
  GESTION_USUARIO_POST_CREAR_DOCUMENTO: '/Operaciones/createDoc',
  GESTION_USUARIO_POST_UPDATE_DOCUMENTO: '/Operaciones/updateDoc',
  GESTION_USUARIO_DELETE_DOCUMENTO: '/Operaciones/deleteDoc',
  GESTION_USUARIO_GET_DOCUMENTS_POR_USUARIO: '/Operaciones/getDocsByUser',
  SEND_PERFIL_EMAIL: '/user/sendDocRegister',

  // HORARIOS --------------------------------------------
  GET_HORARIO_EMPRESA: '/Usuario/GetCompanyHorarios',
  UPDATE_HORARIO_SUCURSAL: '/Usuario/UpdateHorarioSucursal',

  // PERFIL DE USUARIO --------------------------------------------
  PERFIL_USUARIO_GET_USUARIO: '/user/getDatosPerfil',
  PERFIL_USUARIO_CHANGE_SUCURSAL: '/user/changeSelectedSucursal',

  // SUSCRIPCION --------------------------------------------
  SUSCRIPCION_GET_DATOS: '/user/getDatosSuscripcion',
  SUSCRIPCION_GET_VALIDAR_SALDO: '/Usuario/ValidarSaldo',
  SUSCRIPCION_POST_DETALLE_PAGO: '/user/getDetallePago',
  SUSCRIPCION_POST_FACTURAS_DISPONIBLES: '/user/getFacturasDisponibles',
  SUSCRIPCION_POST_SUBIR_COMPROBANTE: '/Operaciones/uploadSuscripcionComprobante',
  SUSCRIPCION_POST_SUBIR_COMPROBANTE_GENERAL: '/Operaciones/uploadSuscripcionComprobanteGeneral',
  SUSCRIPCION_GET_COMPROBANTE: '/user/getDatosComprobante',
  SUSCRIPCION_GET_RECIBO_CLIENTE: '/Operaciones/getReciboDetalle',

  // MANEJO SUCURSALES Y DOCUMENTOS
  GESTION_GET_SUCURSALES: '/sucursales',
  GESTION_SET_NEW_SUCURSALES: '/sucursal/add',
  GESTION_SET_EDIT_SUCURSALES: '/sucursal/update',
  GESTION_SET_DELETE_SUCURSALES: '/sucursal/delete',
  GESTION_SET_ACTIVE_SUCURSALES: '/sucursal/active',
  GESTION_SUCURSALES_DOCUMENTOS: '/sucursales/documento',
  GESTION_SET_ACTIVE_SUCURSALES_DOCUMENTOS: '/sucursales/documento/active',

  // CLIENTE RECEPTOR
  CLIENTE_RECEPTOR_GUARDAR: '/Operaciones/DatosCliente',
  COMPROBANTE_RETENCION_BUSQUEDA_DTE: '/Gateway/BusquedaDTE',

  OBTENER_INFORMACION_PROPINAS: '/Gateway/GetInformacionPropinas',

  // GESTIÓN CLIENTES
  GESTION_CLIENTES_CREATE_CLIENTE: '/Clientes/Create',
  GESTION_CLIENTES_UPDATE_CLIENTE: '/Clientes/Update',
  GESTION_CLIENTES_DELETE_CLIENTE: '/Clientes/Delete',
  GESTION_CLIENTES_GET_CLIENTES: '/Clientes/GetClientes',
  GESTION_CLIENTES_GET_CLIENTE_BY_ID: '/Clientes/GetClienteById',
  GESTION_CLIENTES_CARGAR_NUEVO: '/Clientes/CargarArchivoCliente',

  // CIERRE PERIODO FISCAL
  CIERRE_PERIODO_FISCAL: '/Operaciones/StartClosingFiscalPeriod',

  //GESTIÓN PRODUCTOS
  GESTION_PRODUCTOS_GET_PRODUCTOS: '/Producto/GetProductosGestion',
  GESTION_PRODUCTO_PUT_ESTATUS: '/Producto/ChangeStatusProduct',
  GESTION_PRODUCTO_DELETE_INFO: '/Productos/DeleteProduct',
  GESTION_PRODUCTO_UPDATE_INFO: '/Producto/UpdateProductoSucursalCompleto',
  GESTION_PRODUCTOS_SET_NEW_PRODUCTO: '/Producto/Create',
  GESTION_PRODUCTO_POST_SUCURSALES: '/Producto/GetSucursalesProducto',
  GESTION_PRODUCTO_POST_ASIGNAR_SUCURSALES: '/Producto/InsertProductoSucursal',
  GESTION_PRODUCTO_GET_IDEMPRESA: '/Producto/GetIdEmpresa',
  GESTION_PRODUCTO_CARGAR_NUEVO: '/Producto/CargarArchivoProducto',
  GESTION_PRODUCTO_GET_SUCURSALES_ACTIVAS: '/Producto/GetSucursalesActivasByEmpresa',

  // LIBROS
  CONSULTA_GENERAL_DOCS_VENTAS: '/Gateway/GetConsultaGeneralVentas',
  LIBRO_VENTAS_CARGAR_RETENCIONES: '/Gateway/CargarComprobantesRetenciones',
  LIBRO_VENTAS_RETENCIONES_DETECTADAS: '/Gateway/GetRetencionesDetectadasVentas',
  LIBRO_VENTAS_GENERAR_CONTRIBUYENTES: '/Gateway/GetLibroVentasContribuyentes',
  LIBRO_VENTAS_GENERAR_CF: '/Gateway/GetLibroVentas',
  LIBRO_VENTAS_GET_GENERADOS: '/Gateway/GetLibroVentasGenerados',
  LIBRO_VENTAS_ANULAR: '/Gateway/UpdateAnuladoLibroVentas',

  // LIBROS - COMPRAS
  LIBRO_COMPRAS_GET_GENERADOS: '/Gateway/GetLibroComprasGenerados',
  LIBRO_COMPRAS_CARGAR_NUEVO: '/Gateway/CargarLibroCompras',
  LIBRO_COMPRAS_GET_DETALLADO: '/Gateway/GetLibroCompras',
  LIBRO_COMPRAS_DELETE: '/Operaciones/DeleteLibroComprasYDetalles',
  LIBRO_COMPRAS_EDIT: '/Operaciones/EditLibroCompras',
  LIBRO_COMPRAS_EDIT_CLASIFICACION: '/Operaciones/EditClasificacionCompras',
  LIBRO_COMPRAS_GET_SUJETOS_EXCLUIDOS: '/Operaciones/GetComprasSujetosExcluidos',
  LIBRO_COMPRAS_EDIT_CLASIFICACION_SUJETOS_EXCLUIDOS: '/Operaciones/EditClasificacionSujetosExcluidos',

  // CONSULTA JSON HACIENDA
  LIBRO_CONSULTA_JSON_DTE: '/Gateway/BusquedaJsonDTE',

  // ANEXOS
  LIBRO_CARGAR_ANEXOS: '/Gateway/CargarAnexos',

  // BITACORA
  BITACORA_CORREOS_HISTORIAL: '/Operaciones/HistorialBitacora',
};
